import axios from "../../config/axiosConfig";
import { CREATE_CUSTOMER, GET_CUSTOMERS, CUSTOMER_REQUEST, DELETE_CUSTOMER, UPDATE_CUSTOMER, CUSTOMER_REQUEST_FAILURE } from "../types";
import { getUsers } from './user-actions';

export const getCustomers = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: CUSTOMER_REQUEST });
      return axios.get("/customer/getAll").then((response) => {
        if (response.data) {
          dispatch({ type: GET_CUSTOMERS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });  
      });      
    } catch (error) {
      console.error(error);
      dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const registerCustomer = (user) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CUSTOMER_REQUEST });
      const { auth } = getState();
      return axios.post("/customer/register", user, { params: { userId: auth.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_CUSTOMER, payload: response.data });
        } else {
          dispatch({
            type: CUSTOMER_REQUEST_FAILURE,
            error: "Customer create failed.",
          });
        }
        dispatch(getUsers());
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCustomer = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CUSTOMER_REQUEST });
      const { auth } = getState();
      return axios.put("/customer/update", { id, data }, { params: { userId: auth.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CUSTOMER,
            payload: { id, data: response.data },
          });
          dispatch(getUsers());
        } else {
          dispatch({
            type: CUSTOMER_REQUEST_FAILURE,
            error: "Customer update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCustomerStatus = (id, status) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CUSTOMER_REQUEST });
      const { auth } = getState();
      return axios.put("/customer/updateStatus", { id, status }, { params: { userId: auth.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CUSTOMER,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CUSTOMER_REQUEST_FAILURE,
            error: "Customer status update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCustomer = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CUSTOMER_REQUEST });
      return axios.delete(`/customer/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CUSTOMER, id: id });
        }
        dispatch(getUsers());
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
